import { IS_EMPTY, IS_ARRAY } from "../../constants";

const currentState = {
  companyGroups: {
    data: null,
    error: false,
  },
  companyUsers: null,
  companyNonUsers: null,
  userTitles: {
    data: null,
    error: false,
  },
  companies: {
    data: null,
    error: false,
  },
  isUpdated: true,
  savedUsingButton: false,
  previousLocation: "/usergroupassociate",
};

const reducer = (state = currentState, action) => {
  switch (action.type) {
    case "INSTANTIATE_GROUPS": {
      const groups = { ...state.companyGroups };
      groups.data = action.payload;

      return {
        ...state,
        companyGroups: groups,
      };
    }
    case "SET_GROUPS_ERROR": {
      const groups = { ...state.companyGroups };
      groups.error = true;

      return {
        ...state,
        companyGroups: groups,
      };
    }
    case "CLEAR_GROUPS_ERROR": {
      const groups = { ...state.companyGroups };
      groups.error = false;

      return {
        ...state,
        companyGroups: groups,
      };
    }
    case "INSTANTIATE_USERS":
      return {
        ...state,
        companyUsers: action.payload,
      };
    case "INSTANTIATE_NONUSERS":
      return {
        ...state,
        companyNonUsers: action.payload,
      };
    case "INSTANTIATE_USER_TITLES": {
      const titles = { ...state.userTitles };
      titles.data = action.payload;

      return {
        ...state,
        userTitles: titles,
      };
    }
    case "INSTANTIATE_USER_TITLES_ERROR": {
      const titles = { ...state.userTitles };
      titles.error = true;

      return {
        ...state,
        userTitles: titles,
      };
    }
    case "CLEAR_USER_TITLES_ERROR": {
      const titles = { ...state.userTitles };
      titles.error = false;

      return {
        ...state,
        userTitles: titles,
      };
    }
    case "INSTANTIATE_COMPANIES": {
      const companies = { ...state.companies };
      companies.data = action.payload;

      return {
        ...state,
        companies: companies,
      };
    }
    case "INSTANTIATE_COMPANIES_ERROR": {
      const companies = { ...state.companies };
      companies.error = true;

      return {
        ...state,
        companies: companies,
      };
    }
    case "CLEAR_COMPANIES_ERROR": {
      const companies = { ...state.companies };
      companies.error = false;

      return {
        ...state,
        companies: companies,
      };
    }
    case "ADMIT_USERS": {
      let users = Object.assign([], state.companyUsers);
      let nonUsers = Object.assign([], state.companyNonUsers);

      if (!IS_EMPTY(action.payload)) {
        action.payload.map((usr) => {
          const index = nonUsers.findIndex((user) => user.id === usr.id);
          return nonUsers.splice(index, 1);
        });
        nonUsers = !IS_EMPTY(nonUsers) ? nonUsers : null;
        users = users.concat(action.payload);
      }

      return {
        ...state,
        companyUsers: users,
        companyNonUsers: nonUsers,
      };
    }
    case "EXPEL_COMPANY_USERS": {
      let users = Object.assign([], state.companyUsers);
      let nonUsers = Object.assign([], state.companyNonUsers);

      if (!IS_EMPTY(action.payload)) {
        action.payload.map((usr) => {
          const index = users.findIndex((user) => user.id === usr.id);
          return users.splice(index, 1);
        });
        users = !IS_EMPTY(users) ? users : null;
        nonUsers = nonUsers.concat(action.payload);
      }

      return {
        ...state,
        companyUsers: users,
        companyNonUsers: nonUsers,
      };
    }
    case "UPDATE_USERS": {
      const users = Object.assign([], state.companyUsers);

      if (!IS_EMPTY(action.payload)) {
        action.payload.map((usr) => {
          const index = users.findIndex((user) => user.id === usr.id);
          return users.splice(index, 1, usr);
        });
      }

      return {
        ...state,
        companyUsers: users,
      };
    }
    case "NEW_GROUP": {
      const companyGroups = { ...state.companyGroups };
      const groups = Object.assign([], companyGroups.data);

      groups.push(action.payload);
      companyGroups.data = groups;

      return {
        ...state,
        companyGroups: companyGroups,
      };
    }
    case "DELETE_GROUP": {
      const groups = Object.assign([], state.companyGroups);
      const groupIndex = groups.findIndex(
        (group) => group.id === action.payload
      );

      if (groupIndex >= 0) groups.splice(groupIndex, 1);

      return {
        ...state,
        companyGroups: groups,
      };
    }
    case "NEW_USER": {
      const users = [...state.companyUsers];
      users.push(action.payload);

      return {
        ...state,
        companyUsers: users,
      };
    }
    case "UPDATE_USER": {
      const companyUsers = [...state.companyUsers];
      const i = companyUsers.findIndex((user) => user.id === action.payload.id);

      if (i >= 0) companyUsers.splice(i, 1, action.payload);

      const companyGroups = { ...state.companyGroups };
      const groups = Object.assign([], companyGroups.data);

      for (let x in groups) {
        const users = groups[x].users;
        if (users) {
          const j = users.findIndex((user) => user.id === action.payload.id);

          if (j >= 0) users.splice(j, 1, action.payload);

          groups[x].users = users;
        }
      }

      companyGroups.data = groups;

      return {
        ...state,
        companyUsers: companyUsers,
        companyGroups: companyGroups,
      };
    }
    case "DELETE_USER": {
      const users = Object.assign([], state.companyUsers);
      const userIndex = users.findIndex((user) => user.id === action.payload);

      if (userIndex >= 0) users.splice(userIndex, 1);

      return {
        ...state,
        companyUsers: users,
      };
    }
    case "UPDATE_GROUP": {
      const companyGroups = { ...state.companyGroups };
      const groups = Object.assign([], companyGroups.data);
      const index = groups.findIndex((group) => group.id === action.payload.id);

      if (index >= 0) {
        groups.splice(index, 1, action.payload);
        companyGroups.data = groups;
      }

      return {
        ...state,
        companyGroups: companyGroups,
      };
    }
    case "DELETE_GROUP": {
      const companyGroups = { ...state.companyGroups };
      const groups = Object.assign([], companyGroups.data);
      const index = groups.findIndex((group) => group.id === action.payload.id);

      if (index >= 0) {
        groups.splice(index, 1);
        companyGroups.data = groups;
      }

      return {
        ...state,
        companyGroups: companyGroups,
      };
    }
    case "INSTANTIATE_GROUP_USERS": {
      const companyGroups = { ...state.companyGroups };
      const groups = Object.assign([], companyGroups.data);
      const index = groups.findIndex((group) => group.id === action.payload.id);

      if (index >= 0) {
        const group = groups[index];
        group.users = action.payload.users;
        groups[index] = group;
        companyGroups.data = groups;
      }

      return {
        ...state,
        companyGroups: companyGroups,
      };
    }
    case "INSTANTIATE_GROUP_NONUSERS": {
      const companyGroups = { ...state.companyGroups };
      const groups = Object.assign([], companyGroups.data);
      const index = groups.findIndex((group) => group.id === action.payload.id);

      if (index >= 0) {
        const group = groups[index];
        group.nonUsers = action.payload.users;
        groups[index] = group;
        companyGroups.data = groups;
      }

      return {
        ...state,
        companyGroups: companyGroups,
      };
    }
    case "ADMIT_GROUP_USERS": {
      const companyGroups = Object.assign([], state.companyGroups);
      const groups = Object.assign([], companyGroups.data);
      const index = groups.findIndex((group) => group.id === action.payload.id);

      if (index >= 0) {
        const group = groups[index];
        let users = Object.assign([], group.users);
        let nonUsers = Object.assign([], group.nonUsers);

        if (IS_ARRAY(action.payload.users) && !IS_EMPTY(action.payload.users)) {
          action.payload.users.map((usr) => {
            const i = nonUsers.findIndex((user) => user.id === usr.id);

            if (i >= 0) return nonUsers.splice(i, 1);

            return null;
          });
          nonUsers = !IS_EMPTY(nonUsers) ? nonUsers : null;
          users = users.concat(action.payload.users);
        } else {
          users.push(action.payload.users);
        }

        group.users = users;
        group.nonUsers = nonUsers;
        groups[index] = group;
        companyGroups.data = groups;
      }

      return {
        ...state,
        companyGroups: companyGroups,
      };
    }
    case "EXPEL_GROUP_USERS": {
      const companyGroups = Object.assign([], state.companyGroups);
      const groups = Object.assign([], companyGroups.data);
      const index = groups.findIndex((group) => group.id === action.payload.id);

      if (index >= 0) {
        const group = groups[index];
        let users = Object.assign([], group.users);
        let nonUsers = Object.assign([], group.nonUsers);

        if (!IS_EMPTY(action.payload.users)) {
          action.payload.users.map((usr) => {
            const i = users.findIndex((user) => user.id === usr.id);

            if (i >= 0) return users.splice(i, 1);

            return null;
          });
          users = !IS_EMPTY(users) ? users : null;
          nonUsers = nonUsers.concat(action.payload.users);
        }

        group.users = users;
        group.nonUsers = nonUsers;
        groups[index] = group;
        companyGroups.data = groups;
      }

      return {
        ...state,
        companyGroups: companyGroups,
      };
    }
    case "RESET_GROUPS":
      const groups = { ...state.companyGroups };
      groups.data = null;
      groups.error = false;

      return {
        ...state,
        companyGroups: groups,
      };
    case "RESET_USERS":
      return {
        ...state,
        companyUsers: null,
      };
    case "RESET_NONUSERS":
      return {
        ...state,
        companyNonUsers: null,
      };
    case "CHECK_GROUP_UPDATED":
      return {
        ...state,
        isUpdated: action.payload,
      };
    case "CHECK_IF_SAVED_USING_BUTTON":
      return {
        ...state,
        savedUsingButton: action.payload,
      };
    case "SET_PREVIOUS_LOCATION":
      return {
        ...state,
        previousLocation: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
